// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (-webkit-min-device-pixel-ratio:0){input[data-v-61a4e998],select[data-v-61a4e998],textarea[data-v-61a4e998]{font-size:16px}}.tab-card-layout[data-v-61a4e998]{display:flex!important}.active[data-v-61a4e998]{color:#fb9013!important}.tab-item-text[data-v-61a4e998]{color:rgba(0,0,0,.5);font-family:\"Open Sans\";font-size:10px;font-style:normal;font-weight:700}.tab-add[data-v-61a4e998]{display:flex;height:100%;margin:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
